import { useReducer } from "react";

/**
 * Forces the component to rerender
 */
export function useForceRender() {
    const [refreshCount, dispatch] = useReducer((c) => c + 1, 0);
    return dispatch as () => void;
}
